<div>
  <button
    class="arrow prev"
    (click)="goToPage(currentPage - 1)"
    [attr.disabled]="currentPage === 1 ? true : null"
  >
    <img src="assets/icons/gl_arrow_left.svg" />
  </button>
  <ng-container *ngFor="let page of visiblePages">
    <div
      *ngIf="page > 0; else dots"
      class="page-item"
      [ngClass]="{ 'current-page': page == currentPage }"
      (click)="goToPage(page)"
    >
      {{ page }}
    </div>
    <ng-template #dots>
      <span class="page-item">...</span>
    </ng-template>
  </ng-container>
  <button
    class="arrow next"
    (click)="goToPage(currentPage + 1)"
    [attr.disabled]="currentPage === totalPages ? true : null"
  >
    <img src="assets/icons/gl_arrow_right-pagination.svg" />
  </button>
</div>
